import { render, staticRenderFns } from "./PhoenixWelcomeLeadgen.vue?vue&type=template&id=4f5d2321&scoped=true"
import script from "./PhoenixWelcomeLeadgen.vue?vue&type=script&lang=js"
export * from "./PhoenixWelcomeLeadgen.vue?vue&type=script&lang=js"
import style0 from "./PhoenixWelcomeLeadgen.vue?vue&type=style&index=0&id=4f5d2321&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5d2321",
  null
  
)

export default component.exports